 Merge branch 'validade-documento' into 'main'
 <template>
    <div id="page-wrapper">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-file-text" aria-hidden="true"></i> Tipos de Documentos
          </h1>
          <h3>Será a página dos documentos utilizados dentro de uma rotina</h3>
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /#page-wrapper -->
  </template>
  
  <script>
  export default {
    name: "DocumentTypes",
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/components/pages/DocumentTypes.vue